import { call, put, takeLatest, select, all } from "redux-saga/effects";
import {
  getSearchInfo,
  getAttachedFiles,
  getProfileInfo,
} from "../../api/firestore/search";

import { getUid } from "../../api/auth";

import {
  sagaApiActionsConstructor,
  sagaApiListenerConstructor,
} from "../helpers";

const { requestStart, requestError, requestSuccess } =
  sagaApiActionsConstructor("search");

const apiListeners = sagaApiListenerConstructor("search");

const searchSelector = (state) => state.search;

function* getSearcherInfoSaga() {
  try {
    const { init, data: prevData } = yield select(searchSelector);
    const { uid } = getUid();

    if (init && prevData) return;

    yield requestStart();

    const data = yield call(getSearchInfo);

    if (data[uid]) {
      delete data[uid];
    }

    yield put({
      type: "search/setSearcherInfo",
      payload: { data },
    });
    yield requestSuccess();
  } catch (e) {
    yield requestError("No hemos podido realizar la búsqueda");
    console.log(e);
  }
}

function* getProfileInfoSaga({ payload }) {
  try {
    yield requestStart();

    const [attachments, info] = yield all([
      call(getAttachedFiles, payload.uid),
      call(getProfileInfo, payload.uid),
    ]);

    yield requestSuccess();
    yield put({
      type: "search/setProfileInfo",
      payload: { attachments, info },
    });
  } catch (e) {
    console.log(e);
    yield requestError("No hemos podido obtener completar la operación");
  }
}

function* searcherRootSaga() {
  yield all([
    takeLatest("search/getSearcherInfo", getSearcherInfoSaga),
    takeLatest("search/getProfileInfo", getProfileInfoSaga),
    ...apiListeners,
  ]);
}

export default searcherRootSaga;
